
import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/AssessmentResult/AddAssessmentResult", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SubmitTraineeReviewResult(context, answers) {
    return new Promise((resolve, reject) => {
      axios.post("api/AssessmentResult/SubmitTraineeReviewResult", answers)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SubmitInstructorAssessmentResult(context, answers) {
    return new Promise((resolve, reject) => {
      axios.post("api/AssessmentResult/SubmitInstructorAssessmentResult", answers)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SubmitGeneralPracticalResult(context, answers) {
    return new Promise((resolve, reject) => {
      axios.post("api/AssessmentResult/SubmitGeneralPracticalResult", answers)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/AssessmentResult/GetAll")
        .then((response) => {
          commit('SET_AssessmentResults', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchAssessmentResults({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/AssessmentResult/GetInstructorAssessmentResult", search)
        .then((response) => {
          commit('SET_AssessmentResults', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },

  getAssessmentResultByCode(context, code) {
    return new Promise((resolve, reject) => {
      axios.get("api/AssessmentResult/getAssessmentResultByCode?Code=" + code)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/AssessmentResult/UpdateAssessmentResult?ID=" + item.ID, item)
        .then((response) => {
          debugger;
          commit('UPDATE_AssessmentResult', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID(context, itemid) {
    debugger;
    return new Promise((resolve, reject) => {
      axios.get("API/AssessmentResult/GetAssessmentResult?ID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/AssessmentResult/DeleteAssessmentResult?ID=" + item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getAssessmentResultActions() {
    return new Promise((resolve, reject) => {
      axios.get("api/AssessmentResult/GetAssessmentResultAction")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetFeedBackDetailsByID(context, itemid) {
    debugger;
    return new Promise((resolve, reject) => {
      axios.get("API/AssessmentResult/GetFeedBackDetailsById?ID=" + itemid)
        .then((response) => {
          debugger
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addTask(context, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/AssessmentResult/AddTasksProcess", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetTask(context, itemid) {
    debugger;
    return new Promise((resolve, reject) => {
      axios.get("API/AssessmentResult/GetTasksProcess?AssessmentResultID=" + itemid)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetEmployee() {
    debugger;
    return new Promise((resolve, reject) => {
      axios.get("API/AssessmentResult/GetAccountEmployee")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeTask({ commit }, item) {
    debugger
    //var x = item;
    debugger
    return new Promise((resolve, reject) => {
      axios.delete("api/AssessmentResult/DeleteTask?AssessmentResultID=" + item.AssessmentResultID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetTaskStatus() {
    debugger;
    return new Promise((resolve, reject) => {
      axios.get("API/AssessmentResult/GetTaskStatus")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
